import { removeClass, isNull } from '~/misc/utils'
// import Swiper, { Navigation, Pagination } from 'swiper'
// Swiper.use([Navigation, Pagination])

export default class Home {
    constructor() {
        this.cacheDom()
        //this.initSwipers()
        this.bindEvents()
    }

    cacheDom() {
        this.swipers = document.querySelectorAll('.swiper')
        this.sections = document.querySelectorAll('.best-selling__section')
        this.switch = document.querySelectorAll('.best-selling__buttons .btn--inline')

        this.mobileSwiper = document.querySelectorAll('.mobile-swiper')
        this.desktopSwiper = document.querySelectorAll('.desktop-swiper')
    }

    // initSwipers() {
    //     if (!isNull(this.mobileSwiper)) {
    //         Array.prototype.forEach.call(this.mobileSwiper, (el, i) => {
    //             const options = {
    //                 freeMode: true,
    //                 slidesPerView: 1,
    //                 spaceBetween: 20,
    //                 grabCursor: true,
    //                 navigation: {
    //                     nextEl: `.swiper-button-next-mobile-${i}`,
    //                     prevEl: `.swiper-button-prev-mobile-${i}`,
    //                 },
    //                 pagination: {
    //                     el: `.swiper-pagination-mobile-${i}`,
    //                     type: 'bullets',
    //                     clickable: true,
    //                 },
    //                 breakpoints: {
    //                     768: {
    //                         slidesPerView: 2,
    //                         spaceBetween: 30,
    //                     },
    //                     1024: {
    //                         slidesPerView: 4,

    //                         spaceBetween: 30,
    //                     },
    //                 },
    //             }

    //             new Swiper(el, options)
    //         })
    //     }

    //     if (!isNull(this.desktopSwiper)) {
    //         Array.prototype.forEach.call(this.desktopSwiper, (el, i) => {
    //             const options = {
    //                 freeMode: true,
    //                 slidesPerView: 1,
    //                 spaceBetween: 20,
    //                 grabCursor: true,
    //                 navigation: {
    //                     nextEl: `.swiper-button-next-${i}`,
    //                     prevEl: `.swiper-button-prev-${i}`,
    //                 },
    //                 pagination: {
    //                     el: `.swiper-pagination-${i}`,
    //                     type: 'bullets',
    //                     clickable: true,
    //                 },
    //                 breakpoints: {
    //                     768: {
    //                         slidesPerView: 2,
    //                         spaceBetween: 30,
    //                     },
    //                     1024: {
    //                         slidesPerView: 4,

    //                         spaceBetween: 30,
    //                     },
    //                 },
    //             }

    //             new Swiper(el, options)
    //         })
    //     }
    // }

    bindEvents() {
        if (!isNull(this.switch)) {
            Array.prototype.forEach.call(this.switch, (el, i) => {
                el.addEventListener('click', (e) => this.handleSwitch(e))
                if (i === 0) {
                    el.click()
                }
            })
        }
    }

    handleSwitch(e) {
        const item = e.target.getAttribute('data-section')
        removeClass(this.switch, 'is-active')
        removeClass(this.sections, 'show')
        e.target.classList.add('is-active')

        const section = document.getElementById('best-selling-' + item)

        if (section) {
            section.classList.add('show')
        }
    }
}
